import {
    Box,
    Breadcrumbs,
    Button,
    Card,
    CardContent,
    CardMedia,
    Container,
    CssBaseline,
    Grid,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import AboutUS1 from "../../Images/AboutUS1.png";
import DeepakImage from "../../Images/Deepak.jpeg";
import LinkedInIcon from '@mui/icons-material/LinkedIn';

export default function AboutUs() {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    // Deepak Khanna's LinkedIn URL
    const linkedinUrl = "https://www.linkedin.com/in/deepakkhanna23/";

    const handleImageClick = () => {
        window.open(linkedinUrl, '_blank', 'noopener,noreferrer');
    };

    return (
        <Box sx={{ textAlign: "center", paddingBottom: 5, paddingTop: 15 }}>
            <Box>
                <img
                    src={AboutUS1}
                    alt="Brand Banner"
                    style={{ width: "100%", display: "block", height: '100%' }}
                />
            </Box>

            <Grid sx={{ backgroundColor: "#FFFFFF", paddingTop: 3 }}>
                <Container component="main" maxWidth="lg" sx={{ padding: 2 }}>
                    <Breadcrumbs />
                    <CssBaseline />
                    <Grid container></Grid>
                    <Grid container spacing={3} paddingTop={2} paddingBottom={2}>
                        <Grid item xs={12}>
                            <Typography
                                variant="h4"
                                sx={{ 
                                    fontWeight: "bold", 
                                    fontSize: { lg: "40px", md: "40px", xs: "30px" }, 
                                    marginBottom: 2, 
                                    color: "black" 
                                }}
                            >
                                About Us
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                sx={{
                                    maxWidth: 631,
                                    margin: "0 auto 0rem",
                                    color: "black",
                                    fontSize: "15px",
                                    textAlign:'justify'
                                }}
                            >
                                <strong>Neotel</strong> is a telecommunications leader based in Nauru, committed to transforming the way the world
                                connects. We leverage cutting-edge technology and global partnerships to deliver innovative, reliable,
                                and secure communication solutions. Our mission is to bring world-class connectivity to every corner of
                                the globe, starting from our roots in Nauru.
                            </Typography>
                        </Grid>
                    </Grid>

                    <Box
                        sx={{
                            marginTop: 2,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <Grid 
                            container 
                            spacing={{ xs: 2, sm: 3, md: 4 }} 
                            justifyContent="center" 
                            alignItems="flex-start"
                            sx={{ 
                                paddingLeft: { lg: 0, md: 0, sm: 0, xs: 0 }, 
                                paddingRight: { lg: 0, md: 0, sm: 0, xs: 0 } 
                            }}
                        >
                            {/* Image Section - Left Side */}
                            <Grid 
                                item 
                                lg={5} 
                                md={5} 
                                xs={12} 
                                sx={{ 
                                    display: 'flex', 
                                    justifyContent: { lg: 'flex-end', md: 'flex-end', xs: 'center' },
                                    alignItems: 'flex-start',
                                    position: 'relative'
                                }}
                            >
                                <Card
                                    sx={{
                                        maxWidth: "100%",
                                        "&:hover": {
                                            boxShadow: 15,
                                            cursor: "pointer",
                                            "& .title": { color: "#233A7E" },
                                            transform: 'scale(1.02)',
                                            transition: 'transform 0.3s ease',
                                        },
                                        maxHeight: "100%",
                                        padding: { xs: 1, sm: 2, md: 3 },
                                        backgroundColor: 'transparent',
                                        boxShadow: 'none',
                                        position: 'relative',
                                        cursor: 'pointer'
                                    }}
                                    onClick={handleImageClick}
                                >
                                    <CardMedia
                                        sx={{
                                            height: { xs: 280, sm: 320, md: 360, lg: 400 },
                                            width: { xs: 280, sm: 320, md: 360, lg: 400 },
                                            backgroundSize: "cover",
                                            borderRadius: "50%",
                                            margin: "auto",
                                            border: '5px solid #f0f0f0',
                                            transition: 'all 0.3s ease',
                                            '&:hover': {
                                                border: '5px solid #0077B5',
                                                boxShadow: '0 0 20px rgba(0, 119, 181, 0.3)'
                                            }
                                        }}
                                        image={DeepakImage}
                                        title="Profile Picture - Click to view LinkedIn profile"
                                    />
                                    
                                    {/* LinkedIn Icon Overlay */}
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            bottom: { xs: 10, sm: 15, md: 20 },
                                            right: { xs: 10, sm: 15, md: 20 },
                                            backgroundColor: '#0077B5',
                                            borderRadius: '50%',
                                            padding: { xs: 0.5, sm: 1 },
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxShadow: 2,
                                            transition: 'all 0.3s ease',
                                            '&:hover': {
                                                backgroundColor: '#005885',
                                                transform: 'scale(1.1)'
                                            }
                                        }}
                                    >
                                        <LinkedInIcon 
                                            sx={{ 
                                                color: 'white', 
                                                fontSize: { xs: 20, sm: 25, md: 30 } 
                                            }} 
                                        />
                                    </Box>
                                </Card>
                            </Grid>

                            {/* Text Content Section - Right Side */}
                            <Grid 
                                item 
                                lg={7} 
                                md={7} 
                                xs={12}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'flex-start',
                                    paddingLeft: { xs: 1, sm: 2, md: 0 }
                                }}
                            >
                                <Typography
                                    sx={{
                                        maxWidth: "100%",
                                        margin: "0 0 1rem 0",
                                        color: "black",
                                        fontSize: { lg: "28px", md: "28px", xs: "24px" },
                                        fontWeight: "600",
                                        textAlign: { lg: 'left', md: 'left', xs: 'center' },
                                        lineHeight: 1.2
                                    }}
                                >
                                    Vision Statement from our CEO
                                </Typography>
                                
                                <Typography
                                    sx={{
                                        maxWidth: "100%",
                                        margin: "0 0 1rem 0",
                                        color: "black",
                                        fontSize: "15px",
                                        textAlign: { lg: 'left', md: 'left', xs: 'justify' },
                                        lineHeight: 1.6
                                    }}
                                >
                                    In today's fast-paced world, telecommunication is more than just
                                    a tool for connectivity—it is the backbone of national growth and
                                    progress. It plays a vital role in driving economic development
                                    and uplifting key sectors such as social welfare, education,
                                    commerce, healthcare and employment.
                                </Typography>
                                
                                <Typography
                                    sx={{
                                        maxWidth: "100%",
                                        margin: "0 0 1rem 0",
                                        color: "black",
                                        fontSize: "15px",
                                        textAlign: { lg: 'left', md: 'left', xs: 'justify' },
                                        lineHeight: 1.6
                                    }}
                                >
                                    At Neotel, we take immense pride in being a catalyst for this
                                    transformation in Nauru. As your trusted 4G+ and 5G+ network
                                    provider, we are committed to delivering reliable, affordable and
                                    high-speed voice and data services across every district. Our
                                    focus on service quality ensures that every citizen of Nauru can
                                    experience seamless connectivity, unlocking opportunities for
                                    growth and innovation.
                                </Typography>
                                
                                <Typography
                                    sx={{
                                        maxWidth: "100%",
                                        margin: "0 0 1rem 0",
                                        color: "black",
                                        fontSize: "15px",
                                        textAlign: { lg: 'left', md: 'left', xs: 'justify' },
                                        lineHeight: 1.6
                                    }}
                                >
                                    Our vision extends beyond technology; it is about empowering
                                    our community. By bringing high-speed internet directly to your
                                    doorstep through our fiber-to-home service, we are ensuring
                                    access to the world's possibilities while also creating meaningful
                                    employment opportunities for the people of Nauru. Our
                                    commitment to nurturing local talent and fostering professional
                                    growth reflects our dedication to building a brighter, more
                                    connected future for NAURU.
                                </Typography>
                                
                                <Typography
                                    sx={{
                                        maxWidth: "100%",
                                        margin: "0 0 1rem 0",
                                        color: "black",
                                        fontSize: "15px",
                                        textAlign: { lg: 'left', md: 'left', xs: 'justify' },
                                        lineHeight: 1.6
                                    }}
                                >
                                    As we continue this journey, I extend my heartfelt gratitude to the
                                    people of Nauru for trusting us to be a part of your lives.
                                    Together, we will shape a future where technology empowers
                                    every individual and contributes to the prosperity of NAURU.
                                </Typography>
                                
                                <Typography
                                    sx={{
                                        maxWidth: "100%",
                                        margin: "0 0 0 0",
                                        paddingTop: 2,
                                        color: "black",
                                        fontSize: "15px",
                                        textAlign: { lg: 'left', md: 'left', xs: 'center' },
                                        lineHeight: 1.6,
                                        whiteSpace: "pre-line",
                                    }}
                                >
                                    <strong>Seiuli Deepak Khanna</strong>
                                    {"\n"}CEO and Director
                                    {"\n"}Telikom Nauru Corporation (Neotel)
                                </Typography>

                                {/* LinkedIn Button */}
                                <Box sx={{ 
                                    mt: 2, 
                                    display: 'flex', 
                                    justifyContent: { lg: 'flex-start', md: 'flex-start', xs: 'center' } 
                                }}>
                                    <Button
                                        variant="outlined"
                                        startIcon={<LinkedInIcon />}
                                        onClick={handleImageClick}
                                        sx={{
                                            color: '#0077B5',
                                            borderColor: '#0077B5',
                                            '&:hover': {
                                                backgroundColor: '#0077B5',
                                                color: 'white',
                                                borderColor: '#0077B5'
                                            }
                                        }}
                                    >
                                        Connect on LinkedIn
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
            </Grid>
            
            <Box sx={{ position: "relative", paddingTop: 2 }}>
                {/* Additional content can go here */}
            </Box>
        </Box>
    );
}